import { TTypeOfCodec } from "../../../shared/src/codecs/codec";
import { TAnyDateCodec, date } from "../../../shared/src/codecs/types/date";
import { form, TFormCodec } from "../../../shared/src/codecs/types/form";
import { TAnyLongStringCodec, longString } from "../../../shared/src/codecs/types/longString";
import { required, TRequiredCodec } from "../../../shared/src/codecs/types/required";
import { TAnyUuidCodec, uuid } from "../../../shared/src/codecs/types/uuid";
import { CaseDeadlineType1, TCaseDeadlineType1Codec } from "../CasesDeadlineChange";
import { EmptyObject, TEmptyObjectCodec } from "../EmptyObject";

// Date and reason submit together: the contract block autosaves on a 1000ms debounce,
// which would post the date before the reason was typed. See docs/adr/0022.
export const CreateCaseDeadlineChangeForm: TFormCodec<
    TRequiredCodec<{
        case_id: TAnyUuidCodec,
        deadline_type: TCaseDeadlineType1Codec,
        deadline_date: TAnyDateCodec,
        reason: TAnyLongStringCodec,
    }>
, TEmptyObjectCodec> =
    form(
        required({
            case_id: uuid(),
            deadline_type: CaseDeadlineType1,
            deadline_date: date(),
            reason: longString(),
        }),
        EmptyObject,
    );
export type TCreateCaseDeadlineChangeFormCodec = typeof CreateCaseDeadlineChangeForm;
export type TCreateCaseDeadlineChangeForm = TTypeOfCodec<TCreateCaseDeadlineChangeFormCodec>;

export const DeleteCaseDeadlineChangeForm: TFormCodec<
    TRequiredCodec<{
        id: TAnyUuidCodec,
        case_id: TAnyUuidCodec,
    }>
, TEmptyObjectCodec> =
    form(
        required({
            id: uuid(),
            case_id: uuid(),
        }),
        EmptyObject,
    );
export type TDeleteCaseDeadlineChangeFormCodec = typeof DeleteCaseDeadlineChangeForm;
export type TDeleteCaseDeadlineChangeForm = TTypeOfCodec<typeof DeleteCaseDeadlineChangeForm>;
